<div class="page-header">
  <div class="row align-items-md-center">
    <div class="col-md-12" style="margin-left: 11px">
      <div class="media m-v-10">
        <div
          class="media-body m-l-15 header-borders"
          style="justify-content: space-between; display: flex"
        >
          <h6 class="mb-0 header-label" style="margin-bottom: 0px">
            Asset Issue Types
          </h6>
          <button
            nz-button
            nzType="default"
            (click)="goBack()"
            style="
              box-shadow: 0 4px 12px 0 rgb(123 149 153 / 24%);
              color: #1969cd;
              font-weight: 500;
              float: right;
            "
          >
            <i nz-icon nzType="left"></i> Go back
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

@if (usrAcsErrMsg == false) {
<div>
  @if ((USER_PERMISSIONS.slct_in==1)?true:false) {
  <div nz-row class="gridTop">
    @if (loader) {
    <ds-loading></ds-loading>
    }
    <div class="ds-card grid">
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="gridData"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
        exportFileName="Designations List"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          type="buttons"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="onEdit2(data)">Edit</div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div class="tblDelBtn" (click)="onDelete2(data)">Delete</div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
    @if ((USER_PERMISSIONS.slct_in==1)?false:true) {
    <div class="permMsg">{{ mainMessage }}</div>
    }
  </div>
  }
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="cancel()"
  >
    <ng-container *nzDrawerContent>
      <form nz-form [formGroup]="modelForm">
        <div class="input-row mt-2" nz-row>
          <div
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="24"
            nzLg="24"
            nzXl="24"
            class="schvlmMrgn"
          >
            <div class="inptLbl">
              Asset Name<span style="color: red">*</span>
            </div>
            @if (!delete) {
            <input type="text" nz-input formControlName="ise_type_nm" />
            } @if (delete) {
            <p>{{ delData.ise_type_nm }}</p>
            }
          </div>
          <!-- <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="schvlmMrgn">
              <div class="inptLbl">Model Code<span style="color: red;">*</span></div>
              <input *ngIf="!delete" type="text" nz-input formControlName="mdl_cd" />
              <p *ngIf="delete">{{delData.mdl_cd}}</p>
            </div> -->
          <div
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="24"
            nzLg="24"
            nzXl="24"
            class="schvlmMrgn"
          >
            <div class="inptLbl">
              Description<span style="color: red">*</span>
            </div>
            @if (!delete) {
            <input type="textarea" nz-input formControlName="dscn_tx" />
            } @if (delete) {
            <p>{{ delData.dscn_tx }}</p>
            }
          </div>
          <div
            nz-col
            nzXs="24"
            nzSm="24"
            nzMd="24"
            nzLg="24"
            nzXl="24"
            class="schvlmMrgn"
          >
            <div class="inptLbl">Category<span style="color: red">*</span></div>
            @if (!delete) {
            <nz-select
              class="slctwidth"
              style="width: 100%"
              nzPlaceHolder="Select Categories"
              formControlName="ast_ctgry_id"
            >
              @for (u of ctgryLst; track u) {
              <nz-option
                [nzValue]="u.ast_ctgry_id"
                [nzLabel]="u.ast_ctgry_nm"
              ></nz-option>
              }
            </nz-select>
            } @if (delete) {
            <p>{{ delData.ast_ctgry_nm }}</p>
            }
          </div>
        </div>
        @if (shwschvlymEditDiv==false && shwschvlymDelDiv==false) {
        <button
          nz-button
          nzType="primary"
          class="sbmtBtm"
          (click)="saveModel()"
        >
          Submit
        </button>
        } @if (shwschvlymEditDiv==true && shwschvlymDelDiv==false) {
        <button
          nz-button
          nzType="primary"
          class="sbmtBtm"
          (click)="saveEditModel()"
        >
          Update
        </button>
        } @if (shwschvlymEditDiv==false && shwschvlymDelDiv==true) {
        <button
          nz-button
          nzType="primary"
          class="sbmtBtm"
          nz-popconfirm
          nzPopconfirmTitle="Are you sure delete this ?"
          nzPopconfirmPlacement="bottom"
          (nzOnConfirm)="saveDeleteModel()"
          (nzOnCancel)="oncancel()"
        >
          Delete
        </button>
        }
        <button nz-button nzType="default" class="cnclBtn" (click)="cancel()">
          Cancel
        </button>
        @if (shwLdng) {
        <div
          style="text-align: center; margin-top: 2px; color: rgb(35, 96, 209)"
        >
          <div class="load-4">
            <div class="ring-1"></div>
          </div>
          Please wait....
        </div>
        }
      </form>
    </ng-container>
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
  </nz-result>
</div>
}
